// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gfor","type":"styles_type__34aGM","choices":"styles_choices__3eBhf"};